import {BaseFormModel} from './base-form-model';

export class OrganizationEvent extends BaseFormModel<OrganizationEvent> {
    id: number;
    orgId: number;
    name: string;
    description: string;
    type: string;
    availability: string;
    color: string;
    contrastColor: string;
}
